import {ModuleWithProviders, NgModule} from '@angular/core';
import {SharedComponent} from './shared.component';
import {PreloaderComponent} from './components/preloader/preloader.component';
import {CommonModule} from '@angular/common';
import {QuestionaireComponent} from './components/questionaire/questionaire.component';
import {SlidesComponent} from './components/slides/slides.component';
import {SlideComponent} from './components/slides/slide/slide.component';
import {HeatmapComponent} from './components/slides/heatmap/heatmap.component';
import {HeatmapDirective} from './components/slides/heatmap/heatmap.directive';
import {FormlyModule} from '@ngx-formly/core';
import {FormsModule} from '@angular/forms';
import {SafeHtmlPipe} from './services/safe-html.pipe';
import {Configurations} from 'projects/shared/src/lib/services/configurations';
import {PromoHandlerComponent} from './components/promo-handler/promo-handler.component';
import {RadioFieldWrapperComponent} from './components/formly-components/radio-field-wrapper/radio-field-wrapper.component';
import {VideoPlayerComponent} from './components/video-player/video-player.component';
import {YouTubePlayerModule} from '@angular/youtube-player';
import {NgbAccordionModule, NgbProgressbarModule} from '@ng-bootstrap/ng-bootstrap';
import { PromoCodeHandlerComponent } from './components/promo-code-handler/promo-code-handler.component';
import { AiAssistantComponent } from './components/ai-assistant/ai-assistant.component';
import { MorphComponent } from './components/morph/morph.component';
import { ProgressbarStackedComponent } from './components/progressbar-stacked/progressbar-stacked.component';
import { LineChartFilledComponent } from './components/line-chart-filled/line-chart-filled.component';
import { MixedChartComponent } from './components/mixed-chart/mixed-chart.component';
import { BurnoutChartComponent } from './components/burnout-chart/burnout-chart.component';
import { UserProgressComponent } from './components/user-progress/user-progress.component';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {TextareaAutoresizeDirective} from './services/textarea-autoresize.directive';
import {AiChatComponent} from './components/ai-chat/ai-chat.component';
import {ChatIndexesComponent} from './components/ai-chat/chat-components/chat-indexes/chat-indexes.component';
import {CountDirective} from './services/count-up.directive';
import {ChatArousalPerformanceComponent} from './components/ai-chat/chat-components/chat-arousal-performance/chat-arousal-performance.component';
import {ChatLineProgressComponent} from './components/ai-chat/chat-components/chat-line-progress/chat-line-progress.component';
import {ChatLineChartComponent} from './components/ai-chat/chat-components/chat-line-chart/chat-line-chart.component';
import { ChatMessagesComponent } from './components/ai-chat/chat-components/chat-messeges/chat-messages.component';
import { AnxietyIndexesComponent } from './components/ai-chat/chat-components/anxiety-indexes/anxiety-indexes.component';
import { DepressionIndexesComponent } from './components/ai-chat/chat-components/deprtssion-indexes/depression-indexes.component';
import { PromoInputComponent } from './components/promo-input/promo-input.component';
import { SunChartComponent } from './components/sun-chart/sun-chart.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { MainThesesComponent } from './main-theses/main-theses.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    declarations: [
        SharedComponent,
        PreloaderComponent,
        QuestionaireComponent,
        SlidesComponent,
        SlideComponent,
        HeatmapComponent,
        HeatmapDirective,
        SafeHtmlPipe,
        PromoHandlerComponent,
        RadioFieldWrapperComponent,
        VideoPlayerComponent,
        PromoCodeHandlerComponent,
        AiAssistantComponent,
        MorphComponent,
        ProgressbarStackedComponent,
        LineChartFilledComponent,
        MixedChartComponent,
        BurnoutChartComponent,
        UserProgressComponent,
        TextareaAutoresizeDirective,

        // chat
        CountDirective,
        AiChatComponent,
        ChatIndexesComponent,
        ChatArousalPerformanceComponent,
        ChatLineProgressComponent,
        ChatLineChartComponent,
        ChatMessagesComponent,
        AnxietyIndexesComponent,
        DepressionIndexesComponent,
        PromoInputComponent,
        SunChartComponent,
        BarChartComponent,
        MainThesesComponent
    ],
    imports: [
        CommonModule,
        FormlyModule.forRoot({
            wrappers: [
                {name: 'radio', component: RadioFieldWrapperComponent},
            ],
        }),
        FormsModule,
        YouTubePlayerModule,
        NgbProgressbarModule,
        NgbAccordionModule,
        SlickCarouselModule,
        TranslateModule
    ],
    exports: [
        SharedComponent,
        PreloaderComponent,
        QuestionaireComponent,
        SlidesComponent,
        SlideComponent,
        HeatmapComponent,
        PromoHandlerComponent,
        PromoCodeHandlerComponent,
        VideoPlayerComponent,
        SafeHtmlPipe,
        AiAssistantComponent,
        AiChatComponent,
        MorphComponent,
        ProgressbarStackedComponent,
        LineChartFilledComponent,
        MixedChartComponent,
        BurnoutChartComponent,
        UserProgressComponent,
        MainThesesComponent,

        // chat
        ChatLineProgressComponent,
        ChatIndexesComponent,
        ChatLineChartComponent,
        ChatArousalPerformanceComponent,
        AnxietyIndexesComponent,
        DepressionIndexesComponent,
        SunChartComponent,
        BarChartComponent
    ]
})
export class SharedModule {
    public static forRoot(config: Configurations): ModuleWithProviders<SharedModule> {

        return {
            ngModule: SharedModule,
            providers: [
                {provide: Configurations, useValue: config}
            ]
        };
    }
}
